// 表单数据存储管理器 - 基于sessionStorage的本地存储
import { ALL_FORM_FIELDS } from './fieldDefinitions';

const formDataStorage = {
  // 存储前缀，用于区分不同类型的数据
  STORAGE_PREFIX: 'form_data_',
  VISITED_PREFIX: 'visited_pages_',
  
  // 获取表单数据存储键名
  getFormDataKey: function(pageId) {
    return `${this.STORAGE_PREFIX}${pageId}`;
  },
  
  // 获取访问状态存储键名
  getVisitedKey: function() {
    return this.VISITED_PREFIX;
  },
  
  // 保存表单数据
  saveFormData: function(key, value) {
    const storageKey = this.getFormDataKey(key);
    sessionStorage.setItem(storageKey, JSON.stringify(value));
  },
  
  // 加载表单数据
  loadFormData: function(pageId) {
    
    const storageKey = this.getFormDataKey(pageId);
    const storedData = sessionStorage.getItem(storageKey);
    
    // 如果sessionStorage中有数据，返回存储的数据
    if (storedData) {
      try {
        const formData = JSON.parse(storedData);
        return formData;
      } catch (error) {
        sessionStorage.removeItem(storageKey);
      }
    }
    
    // 如果没有数据，返回 fieldDefinitions 中定义的初始字段
    const initialFields = ALL_FORM_FIELDS[pageId];
    if (initialFields) {
      return initialFields;
    }
    return {};
  },
  
  // 获取所有表单数据（用于调试和导出）
  getAllFormData: function() {
    const allFormData = {};
    
    // 遍历sessionStorage中的所有键值对
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      // 检查键名是否以表单数据前缀开头
      if (key && key.startsWith(this.STORAGE_PREFIX)) {
        try {
          // 提取页面ID（去掉前缀）
          const pageId = key.replace(this.STORAGE_PREFIX, '');
          
          // 获取存储的值并解析JSON
          const storedValue = sessionStorage.getItem(key);
          if (storedValue) {
            const formData = JSON.parse(storedValue);
            allFormData[pageId] = formData;
          }
        } catch (error) {
          // 如果解析失败，跳过该数据
          console.warn(`解析sessionStorage数据失败: ${key}`, error);
        }
      }
    }
    
    return allFormData;
  },
  
  // 标记页面为已访问
  markPageVisited: function(pageId) {
    const visitedKey = this.getVisitedKey();
    const visitedPages = this.getVisitedPages();
    visitedPages[pageId] = true;
    sessionStorage.setItem(visitedKey, JSON.stringify(visitedPages));
  },
  
  // 检查页面是否已访问
  isPageVisited: function(pageId) {
    const visitedPages = this.getVisitedPages();
    const isVisited = visitedPages[pageId] || false;
    return isVisited;
  },
  
  // 获取所有访问状态
  getVisitedPages: function() {
    const visitedKey = this.getVisitedKey();
    const storedVisited = sessionStorage.getItem(visitedKey);
    if (storedVisited) {
      try {
        return JSON.parse(storedVisited);
      } catch (error) {
        sessionStorage.removeItem(visitedKey);
      }
    }
    return {};
  },
  
  // 清除所有表单数据
  clearAllFormData: function() {
    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && (key.startsWith(this.STORAGE_PREFIX) || key.startsWith(this.VISITED_PREFIX))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => sessionStorage.removeItem(key));
  },
  
  // 清除特定页面的表单数据
  clearFormData: function(pageId) {
    const storageKey = this.getFormDataKey(pageId);
    sessionStorage.removeItem(storageKey);
  },
  
  // 检查是否有表单数据
  hasFormData: function(pageId) {
    const storageKey = this.getFormDataKey(pageId);
    return sessionStorage.getItem(storageKey) !== null;
  },
  
  // 获取存储统计信息
  getStorageStats: function() {
    const allData = this.getAllFormData();
    const visitedPages = this.getVisitedPages();
    
    return {
      totalPages: Object.keys(allData).length,
      visitedPages: Object.keys(visitedPages).length,
      totalStorageSize: JSON.stringify(allData).length,
      pages: Object.keys(allData)
    };
  }
};

export default formDataStorage;
